import { useMemo } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { useAuth } from '../../global/contexts/auth/auth';
import { IconLogout } from '../../common/icons';
import { visibleNav } from './nav-items';

import './styles/sidebar.css';

// TSS vite/05 — desktop sidebar. The menu is built from the client's data-roles
// (visibleNav is a builder — allowed outside JSX). Active state via <NavLink>.
// Hidden on mobile (portal-shell.css), where the bottom bar + hamburger drawer
// take over.

export default function Sidebar() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const items = useMemo(() => visibleNav(user?.roles_with_data), [user]);

    const handleLogout = async () => {
        await logout();
        navigate('/login?logout=true', { replace: true });
    };

    const initials = (user?.name || user?.identifier || '?').trim().charAt(0).toUpperCase();

    return (
        <aside className="sidebar">
            <div className="sidebar__brand">
                <span className="sidebar__logo-tile">
                    <img className="sidebar__logo" src="/cowre.png" alt="" aria-hidden="true" />
                </span>
                <span className="sidebar__wordmark">COWRE</span>
            </div>

            <nav className="sidebar__nav">
                <ul className="sidebar__list">
                    {items.map((item) => (
                        <li key={item.key}>
                            <NavLink
                                to={item.to}
                                end={item.end}
                                className={({ isActive }) =>
                                    `sidebar__link ${isActive ? 'sidebar__link--active' : ''}`
                                }
                            >
                                <span className="sidebar__link-icon">{item.icon}</span>
                                <span className="sidebar__link-label">{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="sidebar__footer">
                <NavLink
                    to="/perfil"
                    className={({ isActive }) =>
                        `sidebar__user ${isActive ? 'sidebar__user--active' : ''}`
                    }
                >
                    <span className="sidebar__avatar">{initials}</span>
                    <span className="sidebar__user-meta">
                        <span className="sidebar__user-name">{user?.name || user?.identifier || '—'}</span>
                        <span className="sidebar__user-role">Ver mi cuenta</span>
                    </span>
                </NavLink>
                <button type="button" className="sidebar__logout" onClick={handleLogout}>
                    <IconLogout />
                    <span>Cerrar sesión</span>
                </button>
            </div>
        </aside>
    );
}
